// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   signin.css — Kleido Sign-In Page
   Import once in SignInPage.tsx or its parent route:
     import "./signin.css";
   Tailwind utilities continue to compile as normal.
   This file supplies the custom utility classes + page polish.
   ============================================================ */

/* ------------------------------------------------------------
   1. DESIGN TOKENS
   ------------------------------------------------------------ */
   :root {
    /* Elevation / surface */
    --bg-page:       #050505;
    --elev-0:        #050505;
    --elev-1:        #0a0a0a;
    --elev-2:        #161616;
    --elev-3:        #1e1e1e;
  
    /* Brand */
    --kleido-blue:   #4f8dfd;
    --kleido-purple: #a06bff;
    --kleido-pink:   #e06aff;
  
    /* Derived glows */
    --glow-blue:     0 0 32px 0 rgba(79, 141, 253, 0.25);
    --glow-purple:   0 0 40px 0 rgba(160, 107, 255, 0.22);
    --glow-card:     0 0 0 1px rgba(255, 255, 255, 0.055),
                     0 4px 32px 0  rgba(0, 0, 0, 0.55);
  
    /* Text */
    --text-primary:   #ffffff;
    --text-secondary: #a3a3b8;
    --text-muted:     #6b6b80;
    --text-muted-2:   #4b4b5c;
  
    /* Borders */
    --border-subtle:  rgba(255, 255, 255, 0.07);
    --border-card:    rgba(255, 255, 255, 0.09);
    --border-input:   rgba(255, 255, 255, 0.12);
    --border-focus:   rgba(79, 141, 253, 0.6);
  
    /* Radius */
    --radius-sm:   6px;
    --radius-md:   10px;
    --radius-lg:   16px;
    --radius-xl:   22px;
    --radius-2xl:  30px;
  
    /* Motion */
    --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);
    --duration-fast: 140ms;
    --duration-base: 220ms;
    --duration-slow: 380ms;
  }
  
  /* ------------------------------------------------------------
     2. RESET / BASE  (safe alongside Tailwind's preflight)
     ------------------------------------------------------------ */
  html,
  body {
    background-color: var(--bg-page);
    color: var(--text-primary);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }
  
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  
  /* Global focus ring — accessible, on-brand */
  :focus-visible {
    outline: 2px solid var(--kleido-blue);
    outline-offset: 3px;
    border-radius: var(--radius-sm);
  }
  
  /* ------------------------------------------------------------
     3. CUSTOM UTILITY CLASSES
     ------------------------------------------------------------ */
  
  /* 3a. Page background */
  .bg-page {
    background-color: var(--bg-page);
    color: var(--text-primary);
  }
  
  /* 3b. Elevated card surface */
  .card-elev {
    background-color: var(--elev-2);
    border: 1px solid var(--border-card);
    border-radius: var(--radius-xl);
    box-shadow: var(--glow-card);
    transition:
      box-shadow var(--duration-base) var(--ease-out-expo),
      border-color var(--duration-base) var(--ease-out-expo);
  }
  
  .card-elev:hover {
    border-color: rgba(255, 255, 255, 0.13);
    box-shadow:
      0 0 0 1px rgba(255, 255, 255, 0.08),
      0 8px 48px 0 rgba(0, 0, 0, 0.65),
      var(--glow-purple);
  }
  
  /* 3c. Subtle dot-grid overlay — sits on top of the bg via pseudo */
  .grid-lines {
    position: relative;
    overflow: hidden;
  }
  
  .grid-lines::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background-image:
      radial-gradient(circle at 60% 10%, rgba(160, 107, 255, 0.10) 0%, transparent 55%),
      radial-gradient(circle at 10% 80%, rgba(79, 141, 253, 0.08) 0%, transparent 50%),
      linear-gradient(rgba(255,255,255,0.028) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.028) 1px, transparent 1px);
    background-size:
      100% 100%,
      100% 100%,
      40px 40px,
      40px 40px;
  }
  
  /* Ensure direct children of grid-lines are above the pseudo */
  .grid-lines > * {
    position: relative;
    z-index: 1;
  }
  
  /* 3d. Text helpers */
  .text-secondary {
    color: var(--text-secondary);
  }
  
  .text-muted-2 {
    color: var(--text-muted-2);
  }
  
  /* 3e. Primary button — gradient blue→purple */
  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 11px 24px;
    border: 1px solid gray;
    border-radius: var(--radius-lg);
    background: linear-gradient(
      125deg,
      var(--kleido-blue)  0%,
      var(--glow-card) 100%
    );
    color: #ffffff;
    font-weight: 600;
    font-size: 0.9375rem;
    letter-spacing: 0.01em;
    cursor: pointer;
    transition:
      filter      var(--duration-fast) var(--ease-out-expo),
      box-shadow  var(--duration-fast) var(--ease-out-expo),
      transform   var(--duration-fast) var(--ease-out-expo),
      opacity     var(--duration-fast) var(--ease-out-expo);
    white-space: nowrap;
  }
  
  .btn-primary:hover,
  .btn-primary-hover {
    filter: brightness(1.12) saturate(1.1);
    /* box-shadow:
      0 0 0 1px rgba(79, 141, 253, 0.35),
      0 6px 28px rgba(79, 141, 253, 0.35),
      0 2px 8px  rgba(160, 107, 255, 0.25); */
    transform: translateY(-1px);
  }
  
  .btn-primary:active {
    filter: brightness(0.96);
    transform: translateY(0px);
  }
  
  .btn-primary:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
    filter: none;
  }
  
  /* 3f. Secondary button — glassy outlined */
  .btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 11px 24px;
    border: 1px solid var(--border-input);
    border-radius: var(--radius-lg);
    background: rgba(255, 255, 255, 0.04);
    color: var(--text-primary);
    font-weight: 500;
    font-size: 0.9375rem;
    letter-spacing: 0.01em;
    cursor: pointer;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    transition:
      background    var(--duration-fast) var(--ease-out-expo),
      border-color  var(--duration-fast) var(--ease-out-expo),
      box-shadow    var(--duration-fast) var(--ease-out-expo),
      transform     var(--duration-fast) var(--ease-out-expo);
    white-space: nowrap;
  }
  
  .btn-secondary:hover,
  .btn-secondary-hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.35);
    transform: translateY(-1px);
  }
  
  .btn-secondary:active {
    background: rgba(255, 255, 255, 0.05);
    transform: translateY(0px);
  }
  
  .btn-secondary:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  
  /* ------------------------------------------------------------
     4. LAYOUT — SIGN-IN PAGE SHELL
     ------------------------------------------------------------ */
  
  /* The outer <main> already gets bg-page; this adds the split grid */
  main.bg-page {
    display: grid;
    grid-template-columns: 1fr;   /* mobile: single column */
    min-height: 100svh;
  }
  
  @media (min-width: 1024px) {
    main.bg-page {
      grid-template-columns: 1fr 1fr; /* desktop: 50/50 split */
    }
  }
  
  @media (min-width: 1280px) {
    main.bg-page {
      grid-template-columns: 58fr 42fr; /* desktop wide: left panel larger */
    }
  }
  
  /* ------------------------------------------------------------
     5. LEFT PANEL (desktop showcase / brand area)
     ------------------------------------------------------------ */
  
  .signin-left {
    display: none;
  }
  
  @media (min-width: 1024px) {
    .signin-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 40px 44px;
      min-height: 100svh;
      position: sticky;
      top: 0;
    }
  }
  
  /* Logo area */
  .signin-logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .signin-logo img,
  .signin-logo svg {
    height: 32px;
    width: auto;
  }
  
  /* Info / feature cards inside the left panel */
  .signin-feature-card {
    background: var(--elev-2);
    border: 1px solid var(--border-card);
    border-radius: var(--radius-xl);
    padding: 10px 14px;
    box-shadow:
      0 0 0 1px rgba(255,255,255,0.04),
      0 8px 32px rgba(0,0,0,0.5);
  }
  
  /* Metric / stat chips */
  .signin-metric {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 12px 18px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
  }
  
  .signin-metric-value {
    font-size: 1.375rem;
    font-weight: 700;
    line-height: 1.1;
    background: linear-gradient(
      120deg,
      var(--kleido-blue),
      var(--kleido-purple)
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .signin-metric-label {
    font-size: 0.72rem;
    font-weight: 500;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.07em;
  }
  
  /* Image preview cards */
  .signin-image-card {
    border-radius: var(--radius-lg);
    overflow: hidden;
    border: 1px solid var(--border-subtle);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.55);
    aspect-ratio: 16 / 10;
    background: var(--elev-2);
  }
  
  .signin-image-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform var(--duration-slow) var(--ease-out-expo);
  }
  
  .signin-image-card:hover img {
    transform: scale(1.025);
  }
  
  /* Mini graph SVG polish */
  .minigraph-svg {
    overflow: visible;
  }
  
  .minigraph-svg .graph-line {
    stroke: url(#graphGradient);
    stroke-width: 2;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  
  .minigraph-svg .graph-fill {
    fill: url(#graphFillGradient);
    opacity: 0.3;
  }
  
  /* ------------------------------------------------------------
     6. RIGHT PANEL (sign-in form)
     ------------------------------------------------------------ */
  
  .signin-right {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 20px;
    min-height: 100svh;
  }
  
  @media (min-width: 640px) {
    .signin-right {
      padding: 48px 32px;
    }
  }
  
  @media (min-width: 1024px) {
    .signin-right {
      padding: 48px 56px;
    }
  }
  
  /* The card-elev sign-in form container */
  .signin-form-card {
    width: 100%;
    max-width: 420px;
    padding: 36px 32px;
  }
  
  @media (min-width: 480px) {
    .signin-form-card {
      padding: 40px 36px;
    }
  }
  
  /* Form inputs */
  .signin-input {
    width: 100%;
    padding: 11px 14px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-input);
    background: rgba(255, 255, 255, 0.04);
    color: var(--text-primary);
    font-size: 0.9375rem;
    line-height: 1.5;
    transition:
      border-color var(--duration-fast) var(--ease-out-expo),
      background   var(--duration-fast) var(--ease-out-expo),
      box-shadow   var(--duration-fast) var(--ease-out-expo);
    outline: none;
  }
  
  .signin-input::placeholder {
    color: var(--text-muted);
  }
  
  .signin-input:hover {
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.055);
  }
  
  .signin-input:focus {
    border-color: var(--border-focus);
    background: rgba(79, 141, 253, 0.06);
    box-shadow:
      0 0 0 3px rgba(79, 141, 253, 0.15),
      0 2px 8px rgba(79, 141, 253, 0.08);
  }
  
  /* Password toggle button inside input wrapper */
  .signin-input-wrapper {
    position: relative;
  }
  
  .signin-input-wrapper .toggle-password {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--text-muted);
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: var(--radius-sm);
    transition: color var(--duration-fast) ease;
  }
  
  .signin-input-wrapper .toggle-password:hover {
    color: var(--text-secondary);
  }
  
  .signin-input-wrapper .signin-input {
    padding-right: 44px;
  }
  
  /* Divider row */
  .signin-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--text-muted-2);
    font-size: 0.78rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
  
  .signin-divider::before,
  .signin-divider::after {
    content: "";
    flex: 1 1;
    height: 1px;
    background: var(--border-subtle);
  }
  
  /* OAuth buttons row */
  .signin-oauth-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  
  .signin-oauth-row .btn-secondary {
    width: 100%;
    font-size: 0.875rem;
    padding: 10px 16px;
  }
  
  /* Store-link badges */
  .signin-store-links {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .store-badge {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 8px 14px;
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    background: rgba(255, 255, 255, 0.03);
    font-size: 0.78rem;
    font-weight: 500;
    color: var(--text-secondary);
    text-decoration: none;
    transition:
      background     var(--duration-fast) ease,
      border-color   var(--duration-fast) ease,
      color          var(--duration-fast) ease;
  }
  
  .store-badge:hover {
    background: rgba(255, 255, 255, 0.07);
    border-color: rgba(255, 255, 255, 0.16);
    color: var(--text-primary);
  }
  
  /* Footer / legal links */
  .signin-legal a {
    color: var(--text-muted);
    text-decoration: none;
    transition: color var(--duration-fast) ease;
    font-size: 0.75rem;
  }
  
  .signin-legal a:hover {
    color: var(--text-secondary);
  }
  
  /* "Sign up" / navigation link */
  .signin-link {
    color: var(--kleido-blue);
    text-decoration: none;
    font-weight: 500;
    transition: color var(--duration-fast) ease;
  }
  
  .signin-link:hover {
    color: var(--kleido-purple);
  }
  
  /* ------------------------------------------------------------
     7. GLOW ACCENTS & AMBIENT LAYERS
     ------------------------------------------------------------ */
  
  /* Ambient radial glow behind the form column */
  .signin-right::before {
    content: "";
    position: fixed;
    top: -20%;
    right: -10%;
    width: 60vw;
    height: 80vh;
    pointer-events: none;
    z-index: 0;
    background: radial-gradient(
      ellipse at center,
      rgba(160, 107, 255, 0.07) 0%,
      transparent 65%
    );
  }
  
  .signin-right > * {
    position: relative;
    z-index: 1;
  }
  
  /* Gradient border highlight on the form card (pseudo technique) */
  .signin-form-card.card-elev {
    position: relative;
  }
  
  .signin-form-card.card-elev::after {
    content: "";
    position: absolute;
    inset: -1px;
    border-radius: calc(var(--radius-xl) + 1px);
    background: linear-gradient(
      135deg,
      rgba(79, 141, 253, 0.18) 0%,
      rgba(160, 107, 255, 0.12) 50%,
      transparent 100%
    );
    z-index: -1;
    pointer-events: none;
    opacity: 0;
    transition: opacity var(--duration-base) var(--ease-out-expo);
  }
  
  .signin-form-card.card-elev:focus-within::after {
    opacity: 1;
  }
  
  /* ------------------------------------------------------------
     8. RESPONSIVE CLEANUP
     ------------------------------------------------------------ */
  
  /* Prevent left panel from being visible on mobile */
  @media (max-width: 1023px) {
    .signin-left {
      display: none !important;
    }
  
    .signin-right {
      padding-top: 56px;
      padding-bottom: 56px;
    }
  }
  
  /* Compact form on very small screens */
  @media (max-width: 400px) {
    .signin-form-card {
      padding: 28px 20px;
      border-radius: var(--radius-lg);
    }
  
    .signin-oauth-row {
      grid-template-columns: 1fr;
    }
  }
  
  /* Prevent horizontal overflow at any breakpoint */
  body,
  html,
  main.bg-page {
    max-width: 100vw;
    overflow-x: hidden;
  }
  
  /* ------------------------------------------------------------
     9. ANIMATION — PAGE ENTRANCE
     ------------------------------------------------------------ */
  
  @keyframes fadeUp {
    from {
      opacity: 0;
      transform: translateY(18px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  
  /* Form card entrance */
  .signin-form-card {
    animation: fadeUp var(--duration-slow) var(--ease-out-expo) both;
  }
  
  /* Left panel content stagger */
  .signin-left > *:nth-child(1) { animation: fadeIn 500ms 80ms  var(--ease-out-expo) both; }
  .signin-left > *:nth-child(2) { animation: fadeUp 500ms 160ms var(--ease-out-expo) both; }
  .signin-left > *:nth-child(3) { animation: fadeUp 500ms 240ms var(--ease-out-expo) both; }
  .signin-left > *:nth-child(4) { animation: fadeUp 500ms 320ms var(--ease-out-expo) both; }
  
  /* Respect reduced-motion preference */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-delay:    0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
  
  /* ------------------------------------------------------------
     10. SCROLLBAR POLISH (Webkit)
     ------------------------------------------------------------ */
  
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  ::-webkit-scrollbar-track {
    background: var(--elev-1);
  }
  
  ::-webkit-scrollbar-thumb {
    background: var(--elev-3);
    border-radius: 99px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.15);
  }
  
  /* ------------------------------------------------------------
     11. SELECTION COLOR
     ------------------------------------------------------------ */
  
  ::selection {
    background: rgba(79, 141, 253, 0.3);
    color: #ffffff;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/PublicLayout/SigninPage/Signin.css"],"names":[],"mappings":"AAAA;;;;;;iEAMiE;;AAEjE;;iEAEiE;GAC9D;IACC,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,UAAU;IACV,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,kBAAkB;IAClB,oDAAoD;IACpD,qDAAqD;IACrD;sDACkD;;IAElD,SAAS;IACT,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;;IAEzB,YAAY;IACZ,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,yCAAyC;;IAEzC,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,WAAW;IACX,8CAA8C;IAC9C,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;;mEAEiE;EACjE;;IAEE,gCAAgC;IAChC,0BAA0B;IAC1B,mCAAmC;IACnC,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA,6CAA6C;EAC7C;IACE,qCAAqC;IACrC,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;;mEAEiE;;EAEjE,wBAAwB;EACxB;IACE,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA,8BAA8B;EAC9B;IACE,+BAA+B;IAC/B,oCAAoC;IACpC,+BAA+B;IAC/B,4BAA4B;IAC5B;;4DAEwD;EAC1D;;EAEA;IACE,uCAAuC;IACvC;;;wBAGoB;EACtB;;EAEA,mEAAmE;EACnE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV;;;;0EAIsE;IACtE;;;;eAIW;EACb;;EAEA,8DAA8D;EAC9D;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA,qBAAqB;EACrB;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,8CAA8C;EAC9C;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;IAC/B;;;;KAIC;IACD,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf;;;;2DAIuD;IACvD,mBAAmB;EACrB;;EAEA;;IAEE,sCAAsC;IACtC;;;6CAGyC;IACzC,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA,2CAA2C;EAC3C;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,qCAAqC;IACrC,+BAA+B;IAC/B,qCAAqC;IACrC,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,0BAA0B;IAC1B,kCAAkC;IAClC;;;;6DAIyD;IACzD,mBAAmB;EACrB;;EAEA;;IAEE,qCAAqC;IACrC,sCAAsC;IACtC,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;IACrC,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;;mEAEiE;;EAEjE,oEAAoE;EACpE;IACE,aAAa;IACb,0BAA0B,IAAI,0BAA0B;IACxD,kBAAkB;EACpB;;EAEA;IACE;MACE,8BAA8B,EAAE,yBAAyB;IAC3D;EACF;;EAEA;IACE;MACE,gCAAgC,EAAE,oCAAoC;IACxE;EACF;;EAEA;;mEAEiE;;EAEjE;IACE,aAAa;EACf;;EAEA;IACE;MACE,aAAa;MACb,sBAAsB;MACtB,8BAA8B;MAC9B,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;MAChB,MAAM;IACR;EACF;;EAEA,cAAc;EACd;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA,+CAA+C;EAC/C;IACE,yBAAyB;IACzB,oCAAoC;IACpC,+BAA+B;IAC/B,kBAAkB;IAClB;;gCAE4B;EAC9B;;EAEA,wBAAwB;EACxB;IACE,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,qCAAqC;IACrC,sCAAsC;IACtC,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;;;;KAIC;IACD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,wBAAwB;EACxB;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,sCAAsC;IACtC,0CAA0C;IAC1C,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,+DAA+D;EACjE;;EAEA;IACE,uBAAuB;EACzB;;EAEA,0BAA0B;EAC1B;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;EACd;;EAEA;;mEAEiE;;EAEjE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF;;EAEA,yCAAyC;EACzC;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF;;EAEA,gBAAgB;EAChB;IACE,WAAW;IACX,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC;IACrC,qCAAqC;IACrC,0BAA0B;IAC1B,oBAAoB;IACpB,gBAAgB;IAChB;;;4DAGwD;IACxD,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sCAAsC;IACtC,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;IACjC,oCAAoC;IACpC;;wCAEoC;EACtC;;EAEA,gDAAgD;EAChD;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,2CAA2C;EAC7C;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;;IAEE,WAAW;IACX,SAAO;IACP,WAAW;IACX,gCAAgC;EAClC;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,sCAAsC;IACtC,+BAA+B;IAC/B,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;IACrB;;;8CAG0C;EAC5C;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;IACvC,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,wBAAwB;IACxB,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,gCAAgC;EAChC;IACE,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;mEAEiE;;EAEjE,+CAA+C;EAC/C;IACE,WAAW;IACX,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV;;;;KAIC;EACH;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA,kEAAkE;EAClE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,2CAA2C;IAC3C;;;;;KAKC;IACD,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,6DAA6D;EAC/D;;EAEA;IACE,UAAU;EACZ;;EAEA;;mEAEiE;;EAEjE,oDAAoD;EACpD;IACE;MACE,wBAAwB;IAC1B;;IAEA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;EACF;;EAEA,uCAAuC;EACvC;IACE;MACE,kBAAkB;MAClB,+BAA+B;IACjC;;IAEA;MACE,0BAA0B;IAC5B;EACF;;EAEA,kDAAkD;EAClD;;;IAGE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;mEAEiE;;EAEjE;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;EACrB;;EAEA,uBAAuB;EACvB;IACE,gEAAgE;EAClE;;EAEA,+BAA+B;EAC/B,gCAAgC,uDAAuD,EAAE;EACzF,gCAAgC,uDAAuD,EAAE;EACzF,gCAAgC,uDAAuD,EAAE;EACzF,gCAAgC,uDAAuD,EAAE;;EAEzF,sCAAsC;EACtC;IACE;;;MAGE,qCAAqC;MACrC,qCAAqC;MACrC,sCAAsC;IACxC;EACF;;EAEA;;mEAEiE;;EAEjE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;mEAEiE;;EAEjE;IACE,mCAAmC;IACnC,cAAc;EAChB","sourcesContent":["/* ============================================================\n   signin.css — Kleido Sign-In Page\n   Import once in SignInPage.tsx or its parent route:\n     import \"./signin.css\";\n   Tailwind utilities continue to compile as normal.\n   This file supplies the custom utility classes + page polish.\n   ============================================================ */\n\n/* ------------------------------------------------------------\n   1. DESIGN TOKENS\n   ------------------------------------------------------------ */\n   :root {\n    /* Elevation / surface */\n    --bg-page:       #050505;\n    --elev-0:        #050505;\n    --elev-1:        #0a0a0a;\n    --elev-2:        #161616;\n    --elev-3:        #1e1e1e;\n  \n    /* Brand */\n    --kleido-blue:   #4f8dfd;\n    --kleido-purple: #a06bff;\n    --kleido-pink:   #e06aff;\n  \n    /* Derived glows */\n    --glow-blue:     0 0 32px 0 rgba(79, 141, 253, 0.25);\n    --glow-purple:   0 0 40px 0 rgba(160, 107, 255, 0.22);\n    --glow-card:     0 0 0 1px rgba(255, 255, 255, 0.055),\n                     0 4px 32px 0  rgba(0, 0, 0, 0.55);\n  \n    /* Text */\n    --text-primary:   #ffffff;\n    --text-secondary: #a3a3b8;\n    --text-muted:     #6b6b80;\n    --text-muted-2:   #4b4b5c;\n  \n    /* Borders */\n    --border-subtle:  rgba(255, 255, 255, 0.07);\n    --border-card:    rgba(255, 255, 255, 0.09);\n    --border-input:   rgba(255, 255, 255, 0.12);\n    --border-focus:   rgba(79, 141, 253, 0.6);\n  \n    /* Radius */\n    --radius-sm:   6px;\n    --radius-md:   10px;\n    --radius-lg:   16px;\n    --radius-xl:   22px;\n    --radius-2xl:  30px;\n  \n    /* Motion */\n    --ease-out-expo: cubic-bezier(0.16, 1, 0.3, 1);\n    --duration-fast: 140ms;\n    --duration-base: 220ms;\n    --duration-slow: 380ms;\n  }\n  \n  /* ------------------------------------------------------------\n     2. RESET / BASE  (safe alongside Tailwind's preflight)\n     ------------------------------------------------------------ */\n  html,\n  body {\n    background-color: var(--bg-page);\n    color: var(--text-primary);\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n  }\n  \n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n  \n  /* Global focus ring — accessible, on-brand */\n  :focus-visible {\n    outline: 2px solid var(--kleido-blue);\n    outline-offset: 3px;\n    border-radius: var(--radius-sm);\n  }\n  \n  /* ------------------------------------------------------------\n     3. CUSTOM UTILITY CLASSES\n     ------------------------------------------------------------ */\n  \n  /* 3a. Page background */\n  .bg-page {\n    background-color: var(--bg-page);\n    color: var(--text-primary);\n  }\n  \n  /* 3b. Elevated card surface */\n  .card-elev {\n    background-color: var(--elev-2);\n    border: 1px solid var(--border-card);\n    border-radius: var(--radius-xl);\n    box-shadow: var(--glow-card);\n    transition:\n      box-shadow var(--duration-base) var(--ease-out-expo),\n      border-color var(--duration-base) var(--ease-out-expo);\n  }\n  \n  .card-elev:hover {\n    border-color: rgba(255, 255, 255, 0.13);\n    box-shadow:\n      0 0 0 1px rgba(255, 255, 255, 0.08),\n      0 8px 48px 0 rgba(0, 0, 0, 0.65),\n      var(--glow-purple);\n  }\n  \n  /* 3c. Subtle dot-grid overlay — sits on top of the bg via pseudo */\n  .grid-lines {\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .grid-lines::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    z-index: 0;\n    background-image:\n      radial-gradient(circle at 60% 10%, rgba(160, 107, 255, 0.10) 0%, transparent 55%),\n      radial-gradient(circle at 10% 80%, rgba(79, 141, 253, 0.08) 0%, transparent 50%),\n      linear-gradient(rgba(255,255,255,0.028) 1px, transparent 1px),\n      linear-gradient(90deg, rgba(255,255,255,0.028) 1px, transparent 1px);\n    background-size:\n      100% 100%,\n      100% 100%,\n      40px 40px,\n      40px 40px;\n  }\n  \n  /* Ensure direct children of grid-lines are above the pseudo */\n  .grid-lines > * {\n    position: relative;\n    z-index: 1;\n  }\n  \n  /* 3d. Text helpers */\n  .text-secondary {\n    color: var(--text-secondary);\n  }\n  \n  .text-muted-2 {\n    color: var(--text-muted-2);\n  }\n  \n  /* 3e. Primary button — gradient blue→purple */\n  .btn-primary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 11px 24px;\n    border: 1px solid gray;\n    border-radius: var(--radius-lg);\n    background: linear-gradient(\n      125deg,\n      var(--kleido-blue)  0%,\n      var(--glow-card) 100%\n    );\n    color: #ffffff;\n    font-weight: 600;\n    font-size: 0.9375rem;\n    letter-spacing: 0.01em;\n    cursor: pointer;\n    transition:\n      filter      var(--duration-fast) var(--ease-out-expo),\n      box-shadow  var(--duration-fast) var(--ease-out-expo),\n      transform   var(--duration-fast) var(--ease-out-expo),\n      opacity     var(--duration-fast) var(--ease-out-expo);\n    white-space: nowrap;\n  }\n  \n  .btn-primary:hover,\n  .btn-primary-hover {\n    filter: brightness(1.12) saturate(1.1);\n    /* box-shadow:\n      0 0 0 1px rgba(79, 141, 253, 0.35),\n      0 6px 28px rgba(79, 141, 253, 0.35),\n      0 2px 8px  rgba(160, 107, 255, 0.25); */\n    transform: translateY(-1px);\n  }\n  \n  .btn-primary:active {\n    filter: brightness(0.96);\n    transform: translateY(0px);\n  }\n  \n  .btn-primary:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n    filter: none;\n  }\n  \n  /* 3f. Secondary button — glassy outlined */\n  .btn-secondary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 11px 24px;\n    border: 1px solid var(--border-input);\n    border-radius: var(--radius-lg);\n    background: rgba(255, 255, 255, 0.04);\n    color: var(--text-primary);\n    font-weight: 500;\n    font-size: 0.9375rem;\n    letter-spacing: 0.01em;\n    cursor: pointer;\n    backdrop-filter: blur(6px);\n    -webkit-backdrop-filter: blur(6px);\n    transition:\n      background    var(--duration-fast) var(--ease-out-expo),\n      border-color  var(--duration-fast) var(--ease-out-expo),\n      box-shadow    var(--duration-fast) var(--ease-out-expo),\n      transform     var(--duration-fast) var(--ease-out-expo);\n    white-space: nowrap;\n  }\n  \n  .btn-secondary:hover,\n  .btn-secondary-hover {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.35);\n    transform: translateY(-1px);\n  }\n  \n  .btn-secondary:active {\n    background: rgba(255, 255, 255, 0.05);\n    transform: translateY(0px);\n  }\n  \n  .btn-secondary:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n  }\n  \n  /* ------------------------------------------------------------\n     4. LAYOUT — SIGN-IN PAGE SHELL\n     ------------------------------------------------------------ */\n  \n  /* The outer <main> already gets bg-page; this adds the split grid */\n  main.bg-page {\n    display: grid;\n    grid-template-columns: 1fr;   /* mobile: single column */\n    min-height: 100svh;\n  }\n  \n  @media (min-width: 1024px) {\n    main.bg-page {\n      grid-template-columns: 1fr 1fr; /* desktop: 50/50 split */\n    }\n  }\n  \n  @media (min-width: 1280px) {\n    main.bg-page {\n      grid-template-columns: 58fr 42fr; /* desktop wide: left panel larger */\n    }\n  }\n  \n  /* ------------------------------------------------------------\n     5. LEFT PANEL (desktop showcase / brand area)\n     ------------------------------------------------------------ */\n  \n  .signin-left {\n    display: none;\n  }\n  \n  @media (min-width: 1024px) {\n    .signin-left {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      padding: 40px 44px;\n      min-height: 100svh;\n      position: sticky;\n      top: 0;\n    }\n  }\n  \n  /* Logo area */\n  .signin-logo {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .signin-logo img,\n  .signin-logo svg {\n    height: 32px;\n    width: auto;\n  }\n  \n  /* Info / feature cards inside the left panel */\n  .signin-feature-card {\n    background: var(--elev-2);\n    border: 1px solid var(--border-card);\n    border-radius: var(--radius-xl);\n    padding: 10px 14px;\n    box-shadow:\n      0 0 0 1px rgba(255,255,255,0.04),\n      0 8px 32px rgba(0,0,0,0.5);\n  }\n  \n  /* Metric / stat chips */\n  .signin-metric {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    padding: 12px 18px;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid var(--border-subtle);\n    border-radius: var(--radius-md);\n  }\n  \n  .signin-metric-value {\n    font-size: 1.375rem;\n    font-weight: 700;\n    line-height: 1.1;\n    background: linear-gradient(\n      120deg,\n      var(--kleido-blue),\n      var(--kleido-purple)\n    );\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n  }\n  \n  .signin-metric-label {\n    font-size: 0.72rem;\n    font-weight: 500;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n  }\n  \n  /* Image preview cards */\n  .signin-image-card {\n    border-radius: var(--radius-lg);\n    overflow: hidden;\n    border: 1px solid var(--border-subtle);\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.55);\n    aspect-ratio: 16 / 10;\n    background: var(--elev-2);\n  }\n  \n  .signin-image-card img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    transition: transform var(--duration-slow) var(--ease-out-expo);\n  }\n  \n  .signin-image-card:hover img {\n    transform: scale(1.025);\n  }\n  \n  /* Mini graph SVG polish */\n  .minigraph-svg {\n    overflow: visible;\n  }\n  \n  .minigraph-svg .graph-line {\n    stroke: url(#graphGradient);\n    stroke-width: 2;\n    fill: none;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }\n  \n  .minigraph-svg .graph-fill {\n    fill: url(#graphFillGradient);\n    opacity: 0.3;\n  }\n  \n  /* ------------------------------------------------------------\n     6. RIGHT PANEL (sign-in form)\n     ------------------------------------------------------------ */\n  \n  .signin-right {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 32px 20px;\n    min-height: 100svh;\n  }\n  \n  @media (min-width: 640px) {\n    .signin-right {\n      padding: 48px 32px;\n    }\n  }\n  \n  @media (min-width: 1024px) {\n    .signin-right {\n      padding: 48px 56px;\n    }\n  }\n  \n  /* The card-elev sign-in form container */\n  .signin-form-card {\n    width: 100%;\n    max-width: 420px;\n    padding: 36px 32px;\n  }\n  \n  @media (min-width: 480px) {\n    .signin-form-card {\n      padding: 40px 36px;\n    }\n  }\n  \n  /* Form inputs */\n  .signin-input {\n    width: 100%;\n    padding: 11px 14px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border-input);\n    background: rgba(255, 255, 255, 0.04);\n    color: var(--text-primary);\n    font-size: 0.9375rem;\n    line-height: 1.5;\n    transition:\n      border-color var(--duration-fast) var(--ease-out-expo),\n      background   var(--duration-fast) var(--ease-out-expo),\n      box-shadow   var(--duration-fast) var(--ease-out-expo);\n    outline: none;\n  }\n  \n  .signin-input::placeholder {\n    color: var(--text-muted);\n  }\n  \n  .signin-input:hover {\n    border-color: rgba(255, 255, 255, 0.2);\n    background: rgba(255, 255, 255, 0.055);\n  }\n  \n  .signin-input:focus {\n    border-color: var(--border-focus);\n    background: rgba(79, 141, 253, 0.06);\n    box-shadow:\n      0 0 0 3px rgba(79, 141, 253, 0.15),\n      0 2px 8px rgba(79, 141, 253, 0.08);\n  }\n  \n  /* Password toggle button inside input wrapper */\n  .signin-input-wrapper {\n    position: relative;\n  }\n  \n  .signin-input-wrapper .toggle-password {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    color: var(--text-muted);\n    display: flex;\n    align-items: center;\n    padding: 4px;\n    border-radius: var(--radius-sm);\n    transition: color var(--duration-fast) ease;\n  }\n  \n  .signin-input-wrapper .toggle-password:hover {\n    color: var(--text-secondary);\n  }\n  \n  .signin-input-wrapper .signin-input {\n    padding-right: 44px;\n  }\n  \n  /* Divider row */\n  .signin-divider {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    color: var(--text-muted-2);\n    font-size: 0.78rem;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n  }\n  \n  .signin-divider::before,\n  .signin-divider::after {\n    content: \"\";\n    flex: 1;\n    height: 1px;\n    background: var(--border-subtle);\n  }\n  \n  /* OAuth buttons row */\n  .signin-oauth-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n  }\n  \n  .signin-oauth-row .btn-secondary {\n    width: 100%;\n    font-size: 0.875rem;\n    padding: 10px 16px;\n  }\n  \n  /* Store-link badges */\n  .signin-store-links {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n  \n  .store-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    padding: 8px 14px;\n    border: 1px solid var(--border-subtle);\n    border-radius: var(--radius-md);\n    background: rgba(255, 255, 255, 0.03);\n    font-size: 0.78rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    text-decoration: none;\n    transition:\n      background     var(--duration-fast) ease,\n      border-color   var(--duration-fast) ease,\n      color          var(--duration-fast) ease;\n  }\n  \n  .store-badge:hover {\n    background: rgba(255, 255, 255, 0.07);\n    border-color: rgba(255, 255, 255, 0.16);\n    color: var(--text-primary);\n  }\n  \n  /* Footer / legal links */\n  .signin-legal a {\n    color: var(--text-muted);\n    text-decoration: none;\n    transition: color var(--duration-fast) ease;\n    font-size: 0.75rem;\n  }\n  \n  .signin-legal a:hover {\n    color: var(--text-secondary);\n  }\n  \n  /* \"Sign up\" / navigation link */\n  .signin-link {\n    color: var(--kleido-blue);\n    text-decoration: none;\n    font-weight: 500;\n    transition: color var(--duration-fast) ease;\n  }\n  \n  .signin-link:hover {\n    color: var(--kleido-purple);\n  }\n  \n  /* ------------------------------------------------------------\n     7. GLOW ACCENTS & AMBIENT LAYERS\n     ------------------------------------------------------------ */\n  \n  /* Ambient radial glow behind the form column */\n  .signin-right::before {\n    content: \"\";\n    position: fixed;\n    top: -20%;\n    right: -10%;\n    width: 60vw;\n    height: 80vh;\n    pointer-events: none;\n    z-index: 0;\n    background: radial-gradient(\n      ellipse at center,\n      rgba(160, 107, 255, 0.07) 0%,\n      transparent 65%\n    );\n  }\n  \n  .signin-right > * {\n    position: relative;\n    z-index: 1;\n  }\n  \n  /* Gradient border highlight on the form card (pseudo technique) */\n  .signin-form-card.card-elev {\n    position: relative;\n  }\n  \n  .signin-form-card.card-elev::after {\n    content: \"\";\n    position: absolute;\n    inset: -1px;\n    border-radius: calc(var(--radius-xl) + 1px);\n    background: linear-gradient(\n      135deg,\n      rgba(79, 141, 253, 0.18) 0%,\n      rgba(160, 107, 255, 0.12) 50%,\n      transparent 100%\n    );\n    z-index: -1;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity var(--duration-base) var(--ease-out-expo);\n  }\n  \n  .signin-form-card.card-elev:focus-within::after {\n    opacity: 1;\n  }\n  \n  /* ------------------------------------------------------------\n     8. RESPONSIVE CLEANUP\n     ------------------------------------------------------------ */\n  \n  /* Prevent left panel from being visible on mobile */\n  @media (max-width: 1023px) {\n    .signin-left {\n      display: none !important;\n    }\n  \n    .signin-right {\n      padding-top: 56px;\n      padding-bottom: 56px;\n    }\n  }\n  \n  /* Compact form on very small screens */\n  @media (max-width: 400px) {\n    .signin-form-card {\n      padding: 28px 20px;\n      border-radius: var(--radius-lg);\n    }\n  \n    .signin-oauth-row {\n      grid-template-columns: 1fr;\n    }\n  }\n  \n  /* Prevent horizontal overflow at any breakpoint */\n  body,\n  html,\n  main.bg-page {\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n  \n  /* ------------------------------------------------------------\n     9. ANIMATION — PAGE ENTRANCE\n     ------------------------------------------------------------ */\n  \n  @keyframes fadeUp {\n    from {\n      opacity: 0;\n      transform: translateY(18px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n  }\n  \n  /* Form card entrance */\n  .signin-form-card {\n    animation: fadeUp var(--duration-slow) var(--ease-out-expo) both;\n  }\n  \n  /* Left panel content stagger */\n  .signin-left > *:nth-child(1) { animation: fadeIn 500ms 80ms  var(--ease-out-expo) both; }\n  .signin-left > *:nth-child(2) { animation: fadeUp 500ms 160ms var(--ease-out-expo) both; }\n  .signin-left > *:nth-child(3) { animation: fadeUp 500ms 240ms var(--ease-out-expo) both; }\n  .signin-left > *:nth-child(4) { animation: fadeUp 500ms 320ms var(--ease-out-expo) both; }\n  \n  /* Respect reduced-motion preference */\n  @media (prefers-reduced-motion: reduce) {\n    *,\n    *::before,\n    *::after {\n      animation-duration: 0.01ms !important;\n      animation-delay:    0.01ms !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n  \n  /* ------------------------------------------------------------\n     10. SCROLLBAR POLISH (Webkit)\n     ------------------------------------------------------------ */\n  \n  ::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n  \n  ::-webkit-scrollbar-track {\n    background: var(--elev-1);\n  }\n  \n  ::-webkit-scrollbar-thumb {\n    background: var(--elev-3);\n    border-radius: 99px;\n  }\n  \n  ::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.15);\n  }\n  \n  /* ------------------------------------------------------------\n     11. SELECTION COLOR\n     ------------------------------------------------------------ */\n  \n  ::selection {\n    background: rgba(79, 141, 253, 0.3);\n    color: #ffffff;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
